import { render, staticRenderFns } from "./atendimento_nova_anaminese.vue?vue&type=template&id=97348f74&scoped=true&"
import script from "./atendimento_nova_anaminese.vue?vue&type=script&lang=js&"
export * from "./atendimento_nova_anaminese.vue?vue&type=script&lang=js&"
import style0 from "./atendimento_nova_anaminese.vue?vue&type=style&index=0&id=97348f74&scoped=true&lang=css&"
import style1 from "./atendimento_nova_anaminese.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97348f74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VContainer,VDivider,VProgressCircular,VSelect,VTextField,VTextarea})
